module.exports = __webpack_public_path__ + "static/bs-switch-merchant-users-logos-51f4703d8aa62d2d14a2948b95c24673.png";